module.exports = __webpack_public_path__ + "img/record.cbfca3ff.png";